import { useDecisionMakerProfilePageData } from '#src/app/pages/decisionMaker/profile/pageContext';

export function useResponsivenessScoreEnabled(): boolean {
	const {
		data: { responsivenessData },
	} = useDecisionMakerProfilePageData();

	return responsivenessData.isVisible;
}
